import { apiFetch } from './client';
import type { HolidaysData } from '$lib/types';

export const holidaysApi = {
  list: () => apiFetch<HolidaysData>('/holidays')
};
